<template>
  <v-navigation-drawer v-model="drawer" width="270">
    <v-container height="100%" class="d-flex flex-column justify-space-between">
      <div>
        <v-sheet>
          <v-btn
            v-if="!$store.state.isMobile"
            height="48"
            size="small"
            block
            rounded="xl"
            color="blue-lighten-1"
            class="mb-4"
            @click="newMail()"
          >
            Написать
            <v-icon class="ml-2" icon="mdi-pencil"></v-icon>
          </v-btn>
          <v-list density="compact" nav color="#10A6F2">
            <v-list-item
              rounded="xl"
              nav
              :value="mailItem"
              v-for="mailItem in $store.state.mailbox"
              :key="mailItem.title"
              @click="handleItemClick(mailItem)"
              :active="selectNav[0] === mailItem"
            >
              <template v-slot:prepend>
                <v-icon class="mr-2" icon="mdi-gmail"
                  ><svg
                    width="34"
                    height="34"
                    viewBox="0 0 34 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M31.96 17.3542C31.96 16.2492 31.8608 15.1867 31.6767 14.1667H17V20.2017H25.3867C25.0183 22.1425 23.9133 23.7858 22.2558 24.8908V28.815H27.3133C30.26 26.095 31.96 22.1 31.96 17.3542Z"
                      fill="#4285F4"
                    />
                    <path
                      d="M17 32.5833C21.2075 32.5833 24.735 31.195 27.3133 28.815L22.2558 24.8908C20.8675 25.8258 19.0967 26.3925 17 26.3925C12.9483 26.3925 9.50583 23.6583 8.27333 19.975H3.08833V23.9983C5.6525 29.0842 10.9083 32.5833 17 32.5833Z"
                      fill="#34A853"
                    />
                    <path
                      d="M8.27333 19.9608C7.96166 19.0258 7.7775 18.0342 7.7775 17C7.7775 15.9658 7.96166 14.9742 8.27333 14.0392V10.0158H3.08833C2.02583 12.1125 1.41666 14.4783 1.41666 17C1.41666 19.5217 2.02583 21.8875 3.08833 23.9842L7.12583 20.8392L8.27333 19.9608Z"
                      fill="#FBBC05"
                    />
                    <path
                      d="M17 7.62166C19.295 7.62166 21.335 8.41499 22.9642 9.94499L27.4267 5.48249C24.7208 2.96082 21.2075 1.41666 17 1.41666C10.9083 1.41666 5.6525 4.91582 3.08833 10.0158L8.27333 14.0392C9.50583 10.3558 12.9483 7.62166 17 7.62166Z"
                      fill="#EA4335"
                    />
                  </svg>
                </v-icon>
                {{ mailItem.title }}
              </template>
            </v-list-item>
          </v-list>
        </v-sheet>

        <v-sheet
          border
          rounded="lg"
          class="pa-1"
          color="#F7F7F9"
          v-if="selectNav.length > 0"
        >
          <v-list
            density="compact"
            nav
            color="#10A6F2"
            v-model:selected="selectFolder"
            @click="
              getSelectFolder();
              isModal = false;
            "
          >
            <v-list-item-subtitle> Папки </v-list-item-subtitle>
            <v-list-item
              rounded="xl"
              nav
              :value="folder"
              v-for="(folder, index) in selectNav[0].folders"
              :key="folder.title"
            >
              <v-list-item-title> {{ folder.title }} </v-list-item-title>
              <template v-slot:prepend>
                <v-icon :icon="folder.icon"></v-icon>
              </template>
              <template
                v-if="
                  index == 0 &&
                  Object.values(folder.items).reduce((acc, category) => {
                    return (
                      acc +
                      category.mails.filter(
                        (mails) => mails.flag.isSeen === false
                      ).length
                    );
                  }, 0) > 0
                "
                v-slot:append
              >
                <v-chip color="#10A6F2">
                  {{
                    Object.values(folder.items).reduce((acc, category) => {
                      return (
                        acc +
                        category.mails.filter(
                          (mails) => mails.flag.isSeen === false
                        ).length
                      );
                    }, 0)
                  }}
                </v-chip>
              </template>
            </v-list-item>

            <!--<v-list-item
              rounded="xl"
              nav
              value="journal"
              @click="
                title = 'Журнал электронной почты';
                isModal = false;
              "
            >
              <v-list-item-title class="ma-0"> Журнал </v-list-item-title>
              <template v-slot:prepend>
                <v-icon icon="mdi-book-open-variant" class="ma-0"></v-icon>
              </template>
            </v-list-item>-->
          </v-list>
        </v-sheet>
      </div>

      <v-list-item
        nav
        value="settings"
        @click="isSetting = !isSetting"
        rounded="xl"
      >
        <v-list-item-title> Настройки </v-list-item-title>
        <template v-slot:prepend>
          <svg
            class="mr-2"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_293_1271)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.414 2.10056C12.633 1.31951 11.3667 1.31951 10.5856 2.10056L8.68609 4.00005H5.99978C4.89521 4.00005 3.99978 4.89548 3.99978 6.00005V8.68636L2.10032 10.5858C1.31927 11.3669 1.31927 12.6332 2.10031 13.4143L3.99978 15.3137V18.0001C3.99978 19.1046 4.89521 20.0001 5.99978 20.0001H8.68609L10.5856 21.8995C11.3667 22.6806 12.633 22.6806 13.414 21.8995L15.3135 20.0001H17.9998C19.1044 20.0001 19.9998 19.1046 19.9998 18.0001V15.3138L21.8993 13.4143C22.6804 12.6332 22.6804 11.3669 21.8993 10.5858L19.9998 8.68632V6.00005C19.9998 4.89548 19.1044 4.00005 17.9998 4.00005H15.3135L13.414 2.10056ZM11.9998 3.51477L13.8993 5.41426C14.2744 5.78934 14.7831 6.00005 15.3135 6.00005H17.9998V8.68632C17.9998 9.21676 18.2105 9.72547 18.5856 10.1005L20.4851 12.0001L18.5856 13.8996C18.2105 14.2746 17.9998 14.7833 17.9998 15.3138V18.0001H15.3135C14.7831 18.0001 14.2744 18.2108 13.8993 18.5858L11.9998 20.4853L10.1003 18.5858C9.72523 18.2108 9.21653 18.0001 8.68609 18.0001H5.99978V15.3137C5.99978 14.7833 5.78907 14.2746 5.41399 13.8995L3.51452 12.0001L5.41399 10.1006C5.78907 9.7255 5.99978 9.2168 5.99978 8.68636V6.00005H8.68609C9.21652 6.00005 9.72523 5.78934 10.1003 5.41426L11.9998 3.51477ZM9.99981 12C9.99981 10.8954 10.8953 10 11.9998 10C13.1044 10 13.9998 10.8954 13.9998 12C13.9998 13.1046 13.1044 14 11.9998 14C10.8953 14 9.99981 13.1046 9.99981 12ZM11.9998 8C9.79067 8 7.99981 9.79086 7.99981 12C7.99981 14.2091 9.79067 16 11.9998 16C14.209 16 15.9998 14.2091 15.9998 12C15.9998 9.79086 14.209 8 11.9998 8Z"
                fill="#10A6F2"
              />
            </g>
            <defs>
              <clipPath id="clip0_293_1271">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </template>
      </v-list-item>
    </v-container>
  </v-navigation-drawer>

  <v-main>
    <v-container fluid>
      <v-fab
        v-if="
          $store.state.isMobile &&
          !isModal &&
          !sendModal &&
          title != 'Журнал электронной почты'
        "
        app
        location="right bottom"
        size="large"
        color="blue-lighten-1"
        icon="mdi-pencil"
        @click="newMail()"
      ></v-fab>
      <v-row v-if="!isModal && !sendModal" class="ma-0 pa-0">
        <v-col cols="12" class="ma-0 pa-4" v-if="!$store.state.isMobile">
          <v-text-field
            v-model="search"
            variant="outlined"
            rounded="lg"
            color="#10A6F2"
            label="Поиск"
            clearable
            hide-details
            prepend-inner-icon="mdi-magnify"
            @click:clear="search = ''"
          >
          </v-text-field>
        </v-col>
        <v-col
          v-else
          class="d-flex justify-space-between ma-0 pa-0 align-center"
        >
          <template v-if="!isSearchMenu">
            <v-btn
              class="ma-0"
              density="compact"
              variant="text"
              @click="drawer = true"
            >
              <template v-slot:prepend>
                <icon>
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.16675 6.49458C2.16675 5.89875 2.64991 5.41666 3.24466 5.41666H11.9222C12.208 5.41666 12.4822 5.53023 12.6844 5.73238C12.8865 5.93453 13.0001 6.2087 13.0001 6.49458C13.0001 6.78046 12.8865 7.05463 12.6844 7.25678C12.4822 7.45893 12.208 7.5725 11.9222 7.5725H3.24466C2.95878 7.5725 2.68461 7.45893 2.48246 7.25678C2.28031 7.05463 2.16675 6.78046 2.16675 6.49458Z"
                      fill="#232526"
                    />
                    <path
                      d="M2.16675 13C2.16675 12.4042 2.64991 11.9221 3.24466 11.9221H22.7555C23.0414 11.9221 23.3156 12.0357 23.5177 12.2378C23.7198 12.44 23.8334 12.7142 23.8334 13C23.8334 13.2859 23.7198 13.5601 23.5177 13.7622C23.3156 13.9644 23.0414 14.078 22.7555 14.078H3.24466C2.95878 14.078 2.68461 13.9644 2.48246 13.7622C2.28031 13.5601 2.16675 13.2859 2.16675 13Z"
                      fill="#232526"
                    />
                    <path
                      d="M3.24466 18.4274C2.95878 18.4274 2.68461 18.541 2.48246 18.7431C2.28031 18.9453 2.16675 19.2194 2.16675 19.5053C2.16675 19.7912 2.28031 20.0654 2.48246 20.2675C2.68461 20.4697 2.95878 20.5832 3.24466 20.5832H16.2555C16.5414 20.5832 16.8156 20.4697 17.0177 20.2675C17.2198 20.0654 17.3334 19.7912 17.3334 19.5053C17.3334 19.2194 17.2198 18.9453 17.0177 18.7431C16.8156 18.541 16.5414 18.4274 16.2555 18.4274H3.24466Z"
                      fill="#232526"
                    />
                  </svg>
                </icon>
              </template>
            </v-btn>
            <v-btn
              class="ma-0"
              density="compact"
              icon="mdi-magnify"
              variant="text"
              @click="isSearchMenu = true"
            ></v-btn>
          </template>
          <template v-else>
            <v-text-field
              v-model="search"
              variant="outlined"
              rounded="lg"
              color="#10A6F2"
              label="Поиск"
              clearable
              hide-details
            >
              <template v-slot:append-inner>
                <v-icon v-if="model" icon="mdi-check-circle" />
              </template>
              <template v-slot:prepend-inner>
                <v-icon
                  icon="mdi-chevron-left"
                  @click.stop="isSearchMenu = false"
                ></v-icon>
              </template>
            </v-text-field>
          </template>
        </v-col>
      </v-row>
      <v-row>
        <template v-if="title == 'Журнал электронной почты'">
          <template v-if="$store.state.isMobile">
            <v-list>
              <template v-for="item in jornalItems" :key="item.id">
                <v-list-item>
                  <v-row class="ma-0 pa-0" justify="space-between">
                    <v-col cols="10" class="ma-0 pa-0 mb-2">
                      <h4>{{ item.title }}</h4>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="1">
                      <v-btn
                        color="#616161"
                        density="compact"
                        icon="mdi-folder-open"
                        variant="text"
                        @click="item.jsonDialog = !item.jsonDialog"
                      ></v-btn>
                      <v-bottom-sheet v-model="item.jsonDialog">
                        <v-card class="pa-4 align-center rounded-t-xl">
                          <v-card-title> JSON information </v-card-title>
                          <v-card-text>
                            {{ item.json }}
                          </v-card-text>
                          <v-card-action class="justify-center">
                            <v-btn
                              color="blue-lighten-1"
                              text="Скопировать"
                              variant="flat"
                              size="large"
                              rounded="xl"
                              @click="item.jsonDialog = !item.jsonDialog"
                            ></v-btn>
                          </v-card-action>
                        </v-card>
                      </v-bottom-sheet>
                    </v-col>
                  </v-row>
                  <v-row class="ma-0 pa-0">
                    <v-col cols="4" class="ma-0 pa-0">
                      <v-list-item-subtitle>Дата</v-list-item-subtitle>
                    </v-col>
                    <v-col class="ma-0 pa-0">{{ item.date }}</v-col>
                  </v-row>
                  <v-row class="ma-0 pa-0">
                    <v-col cols="4" class="ma-0 pa-0">
                      <v-list-item-subtitle>От кого</v-list-item-subtitle>
                    </v-col>
                    <v-col class="ma-0 pa-0">{{ item.from_email }}</v-col>
                  </v-row>
                  <v-row class="ma-0 pa-0">
                    <v-col cols="4" class="ma-0 pa-0">
                      <v-list-item-subtitle>Кому</v-list-item-subtitle>
                    </v-col>
                    <v-col class="ma-0 pa-0">{{ item.to_email }}</v-col>
                  </v-row>
                </v-list-item>
                <v-divider class="mb-2"></v-divider>
              </template>
            </v-list>
          </template>
          <template v-else>
            <v-row>
              <v-col>
                <v-table
                  class="ma-2 rounded-t-lg"
                  fixed-header
                  :height="$store.state.height - 200"
                >
                  <thead>
                    <tr>
                      <th
                        v-for="header in headers"
                        :key="header.title"
                        style="background-color: #bbdefb"
                      >
                        {{ header.title }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in jornalItems"
                      :key="item.id"
                      @click="openMail(item)"
                    >
                      <td>{{ item.id }}</td>
                      <td>{{ item.title }}</td>
                      <td>{{ item.date }}</td>
                      <td>{{ item.from_email }}</td>
                      <td>{{ item.from_name }}</td>
                      <td>{{ item.to_email }}</td>
                      <td>
                        <v-btn
                          color="#616161"
                          density="compact"
                          icon="mdi-folder-open"
                          variant="text"
                          @click="item.jsonDialog = !item.jsonDialog"
                        ></v-btn>
                      </td>
                      <v-dialog v-model="item.jsonDialog" width="800">
                        <v-card rounded="xl" class="pa-4 align-center">
                          <v-card-title> JSON information </v-card-title>
                          <v-card-text>
                            {{ item.json }}
                          </v-card-text>
                          <v-card-action class="justify-center">
                            <v-btn
                              color="blue-lighten-1"
                              text="Скопировать"
                              variant="flat"
                              size="large"
                              rounded="xl"
                              @click="item.jsonDialog = !item.jsonDialog"
                            ></v-btn>
                          </v-card-action>
                        </v-card>
                      </v-dialog>
                    </tr>
                  </tbody>
                </v-table>
              </v-col>
            </v-row>
          </template>
        </template>
        <template v-else>
          <template v-if="sendModal">
            <SendModal
              :item="item"
              v-model:modal="sendModal"
              :newMail="isNewMail"
              :fwd="fwd"
              :index="index"
            />
          </template>
          <template v-else-if="isModal">
            <Modal
              :item="item"
              v-model:modal="isModal"
              v-model:favorite="item.favorite"
              v-model:sendModal="sendModal"
              v-model:newMail="isNewMail"
              v-model:fwd="fwd"
              :index="index"
              @deleteMail="deleteMail"
            />
          </template>
          <template v-else>
            <template v-if="selectFolder.length > 0">
              <v-col
                v-for="item in selectFolder[0].items"
                :key="item.title"
                cols="12"
                class="ma-0 pa-0"
              >
                <v-card elevation="0" v-if="item.mails.length > 0">
                  <v-list :lines="$store.state.isMobile ? 'one' : 'two'">
                    <v-list-subheader :title="item.title"></v-list-subheader>
                    <template
                      v-for="mail in filterMails(item.mails, search)"
                      :key="mail.id"
                    >
                      <v-list-item @click="openMail(mail)">
                        <v-list-item class="ma-0 pb-0">
                          <template v-slot:prepend>
                            <v-icon
                              icon="mdi-circle-medium"
                              style="position: absolute; left: -5px"
                              color="blue"
                              v-if="mail.flag.isSeen == false"
                            />
                            <v-avatar size="52" color="primary">
                              <img
                                width="52"
                                v-if="mail.icon"
                                :src="mail.icon"
                                alt="Avatar"
                              />
                              <span v-else class="text-h6">U</span>
                            </v-avatar>
                          </template>
                          <template v-slot:append>
                            <div class="d-flex flex-column">
                              <v-list-item-subtitle style="align-self: end">
                                {{
                                  item.title == "Сегодня" ||
                                  item.title == "Вчера"
                                    ? mail.timeTitle
                                    : mail.dateTitle
                                }}</v-list-item-subtitle
                              >

                              <div class="d-flex justify-end align-center">
                                <v-icon
                                  v-if="mail.attachment"
                                  icon="mdi-paperclip"
                                ></v-icon>
                                <!--<v-btn
                                  style="align-self: end"
                                  :color="mail.favorite ? 'yellow' : 'black'"
                                  :icon="
                                    mail.favorite
                                      ? 'mdi-star'
                                      : 'mdi-star-outline'
                                  "
                                  variant="text"
                                  @click.stop="mail.favorite = !mail.favorite"
                                ></v-btn>-->
                              </div>
                            </div>
                          </template>
                          <v-list-item-title>
                            {{ mail.fromName }}</v-list-item-title
                          >
                          <v-list-item-title>
                            {{ mail.subject }}</v-list-item-title
                          >
                        </v-list-item>
                      </v-list-item>
                      <v-divider></v-divider>
                    </template>
                  </v-list>
                </v-card>
              </v-col>
            </template>
          </template>
        </template>
      </v-row>
      <v-dialog
        v-model="isSetting"
        :fullscreen="$store.state.isMobile"
        v-touch="{
          right: () => (isSetting = false),
        }"
      >
        <v-card
          v-touch="{
            right: () => (isSetting = false),
          }"
          :rounded="$store.state.isMobile ? '' : 'xl'"
        >
          <Setting v-model="isSetting" @deleteSetting="deleteSetting" />
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>
<script>
import Modal from "./Modal.vue";
import SendModal from "./SendModal.vue";
import Setting from "./Setting.vue";
import axios from "axios";

export default {
  name: "Main-component",
  components: {
    Modal,
    Setting,
    SendModal,
  },
  data() {
    return {
      index: null,
      isNewMail: false,
      fwd: false,
      sendModal: false,
      isSearchMenu: false,
      isModal: false,
      isSetting: false,
      drawer: true,
      selectNav: [],
      selectFolder: [],
      item: {},
      search: "",
      headers: [
        {
          title: "ID",
          align: "start",
          sortable: true,
          key: "id",
        },
        {
          title: "Название",
          align: "start",
          sortable: false,
          key: "title",
        },
        {
          title: "Дата",
          align: "start",
          sortable: true,
          key: "date",
        },
        {
          title: "От кого(email)",
          align: "start",
          sortable: false,
          key: "from_email",
        },
        {
          title: "От кого(Имя)",
          align: "start",
          sortable: false,
          key: "from_name",
        },
        {
          title: "Кому",
          align: "start",
          sortable: false,
          key: "to_email",
        },
        {
          title: "Json",
          align: "start",
          sortable: false,
          key: "json",
        },
      ],
      jornalItems: [
        {
          id: 1,
          title:
            "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Neque.",
          date: "20.12.2024",
          text: "",
          from_email: "kjg@jh.ru",
          from_name: "hjg",
          to_email: "jhhgc@jhf.ru",
          json: `{
    "name":"John",
    "age":30,
    "cars": [
        { "name":"Ford", "models":[ "Fiesta", "Focus", "Mustang" ] },
        { "name":"BMW", "models":[ "320", "X3", "X5" ] },
        { "name":"Fiat", "models":[ "500", "Panda" ] }
     ]
 }`,
          menu: false,
          jsonDialog: false,
        },
        {
          id: 2,
          title: "kgh",
          date: "22.12.2024",
          text: "",
          from_email: "kjg@jh.ru",
          from_name: "hjg",
          to_email: "jhhgc@jhf.ru",
          json: "jhg",
          menu: false,
          jsonDialog: false,
        },
        {
          id: 2,
          title: "kgh",
          date: "22.12.2024",
          from_email: "kjg@jh.ru",
          from_name: "hjg",
          to_email: "jhhgc@jhf.ru",
          json: "jhg",
          menu: false,
          jsonDialog: false,
        },
      ],
      updateInterval: null,
    };
  },

  methods: {
    async updateMails() {
      try {
        if (this.selectFolder.length > 0) {
          const formData = new FormData();
          formData.append(`params`, "getAllMailsFolderToday");
          formData.append(`login`, this.selectNav[0].title);
          formData.append(`password`, this.selectNav[0].pass);
          formData.append(
            `host`,
            this.$store.state.settings[this.selectNav[0].server].imap.address
          );
          formData.append(
            `port`,
            this.$store.state.settings[this.selectNav[0].server].imap.port
          );
          formData.append(`encrypt`, "ssl");
          formData.append(
            `type`,
            this.selectNav[0].pass ? "password" : "oauth"
          );
          formData.append(`folder_number`, this.selectFolder[0].id);

          const response = await axios.post(
            "https://email.rcgit.ru/imap/",
            formData
          );

          // Группируем новые письма по дате
          const newGroupedMessages = this.groupMessagesByDate(response.data);

          // Обновляем письма в текущей папке, добавляя только новые
          for (const key in newGroupedMessages) {
            if (this.selectFolder[0].items[key]) {
              // Если категория уже существует, добавляем только новые письма
              const existingMails = this.selectFolder[0].items[key].mails;
              const newMails = newGroupedMessages[key].mails;

              // Фильтруем новые письма, оставляя только те, которых ещё нет в existingMails
              const uniqueNewMails = newMails.filter(
                (newMail) =>
                  !existingMails.some(
                    (existingMail) => existingMail.id === newMail.id
                  )
              );

              // Добавляем уникальные новые письма в существующую категорию
              this.selectFolder[0].items[key].mails = [
                ...uniqueNewMails,
                ...existingMails,
              ];
            } else {
              // Если категории нет, добавляем её целиком
              this.selectFolder[0].items[key] = newGroupedMessages[key];
            }
          }

          console.log("Письма обновлены (дополнены)");
        }
      } catch (error) {
        console.error("Ошибка при обновлении писем:", error);
      }
    },
    filterMails(mails, searchQuery) {
      if (!searchQuery) return mails; // Если поисковый запрос пуст, возвращаем все письма

      const query = searchQuery.toLowerCase(); // Приводим запрос к нижнему регистру

      return mails.filter((mail) => {
        console.log({ mail });
        // Ищем по полям subject, fromName и body

        return mail.subject && mail.from
          ? mail.subject.toLowerCase().includes(query) ||
              mail.from.toLowerCase().includes(query)
          : mail.subject
          ? mail.subject.toLowerCase().includes(query)
          : mail.from.toLowerCase().includes(query);
      });
    },
    handleItemClick(item) {
      this.index = this.$store.state.mailbox.findIndex(
        (e) => e.title == item.title
      );
      console.log(this.index);
      // Если кликнули на уже выбранный элемент, ничего не делаем
      if (this.selectNav[0] === item) {
        return;
      }
      // Иначе обновляем выбранный элемент
      this.selectNav = [item];
      this.changeBox();
      this.isModal = false;
    },

    async changeBox() {
      try {
        console.log(this.selectNav);
        this.selectNav[0].folders = [];

        let formData = new FormData();
        formData.set(`params`, "getUserFolders");
        formData.append(`login`, this.selectNav[0].title);
        formData.append(`password`, this.selectNav[0].pass);
        formData.append(
          `host`,
          this.$store.state.settings[this.selectNav[0].server].imap.address
        );
        formData.append(
          `port`,
          this.$store.state.settings[this.selectNav[0].server].imap.port
        );
        formData.append(`encrypt`, "ssl");
        formData.append(`type`, this.selectNav[0].pass ? "password" : "oauth");
        const folders = await axios.post(
          "https://email.rcgit.ru/imap/",
          formData
        );
        for (const folder of folders.data) {
          this.selectNav[0].folders.push({
            id: folder.id,
            title: folder.name,
            icon: folder.icon,
            items: [],
          });
        }
        formData.set(`params`, "getAllMailsFolder");
        formData.set(`folder_number`, this.selectNav[0].folders[0].id);
        //получить все письма по каждой из папки
        const mails = await axios.post(
          "https://email.rcgit.ru/imap/",
          formData
        );
        this.selectNav[0].folders[0].items = this.groupMessagesByDate(
          mails.data
        );
        this.selectFolder = this.selectNav[0].folders;
      } catch (error) {
        console.log({ error });
      }
    },
    deleteSetting(mailBox) {
      this.isModal = false;
      this.selectNav = [mailBox];
      this.changeBox();
    },
    groupMessagesByDate(messages) {
      const today = new Date(); // Текущая дата
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1); // Вчера
      const lastWeek = new Date(today);
      lastWeek.setDate(today.getDate() - 7); // Неделя назад
      const lastMonth = new Date(today);
      lastMonth.setMonth(today.getMonth() - 1); // Месяц назад

      const groupedMessages = {
        today: {
          title: "Сегодня",
          mails: [],
        },
        yesterday: {
          title: "Вчера",
          mails: [],
        },
        lastWeek: {
          title: "За последную неделю",
          mails: [],
        },
        lastMonth: {
          title: "За последний месяц",
          mails: [],
        },
        older: {
          title: "Больше месяца",
          mails: [],
        },
      };

      messages.forEach((message) => {
        console.log(message.date, "date");
        const messageDate = new Date(message.date);

        if (messageDate.toDateString() === today.toDateString()) {
          groupedMessages.today.mails.push(message); // Сегодня
        } else if (messageDate.toDateString() === yesterday.toDateString()) {
          groupedMessages.yesterday.mails.push(message); // Вчера
        } else if (messageDate > lastWeek) {
          groupedMessages.lastWeek.mails.push(message); // За последнюю неделю
        } else if (messageDate > lastMonth) {
          groupedMessages.lastMonth.mails.push(message); // За последний месяц
        } else {
          groupedMessages.older.mails.push(message); // Старое
        }
      });

      return groupedMessages;
    },
    async getSelectFolder() {
      try {
        let formData = new FormData();
        formData.append(`login`, this.selectNav[0].title);
        formData.append(`password`, this.selectNav[0].pass);
        formData.append(
          `host`,
          this.$store.state.settings[this.selectNav[0].server].imap.address
        );
        formData.append(
          `port`,
          this.$store.state.settings[this.selectNav[0].server].imap.port
        );
        console.log(
          this.$store.state.settings[this.selectNav[0].server].imap.port
        );
        formData.append(`encrypt`, "ssl");
        formData.append(`type`, this.selectNav[0].pass ? "password" : "oauth");
        formData.append(`params`, "getAllMailsFolder");
        formData.append(`folder_number`, this.selectFolder[0].id);
        //получить все письма по каждой из папки
        const mails = await axios.post(
          "https://email.rcgit.ru/imap/",
          formData
        );
        console.log(this.selectFolder);
        this.selectFolder[0].items = this.groupMessagesByDate(mails.data);
        console.log({ mails });
      } catch (error) {
        console.log({ error });
      }
    },
    newMail() {
      this.isNewMail = true;
      this.fwd = false;
      this.item = {};
      this.sendModal = !this.sendModal;
      this.isModal = false;
    },
    deleteMail(item) {
      try {
        console.log({ item });
        for (const key in this.selectFolder[0].items) {
          const category = this.selectFolder[0].items[key];

          // Фильтруем массив cards, удаляя элемент с id === 3
          category.mails = category.mails.filter((mail) => mail.id !== item.id);
        }
      } catch (error) {
        console.log({ error });
      }
    },
    async openMail(item) {
      let formData = new FormData();
      formData.append(`params`, "getBodyMail");
      formData.append(`login`, this.selectNav[0].title);
      formData.append(`password`, this.selectNav[0].pass);
      formData.append(
        `host`,
        this.$store.state.settings[this.selectNav[0].server].imap.address
      );
      formData.append(
        `port`,
        this.$store.state.settings[this.selectNav[0].server].imap.port
      );
      formData.append(`encrypt`, "ssl");
      formData.append(`type`, this.selectNav[0].pass ? "password" : "oauth");
      formData.append(`folder_number`, this.selectFolder[0].id);
      formData.append(`id`, item.id);

      //получить все письма по каждой из папки
      const mail = await axios.post("https://email.rcgit.ru/imap/", formData);
      console.log({ mail });
      this.isModal = true;
      item.body = mail.data.body;
      item.files = mail.data.files;
      item.folderId = this.selectFolder[0].id;
      item.flag.isSeen = true;
      this.item = item;
    },
  },
  async mounted() {
    if (this.$store.state.isMobile) this.drawer = false;
    this.selectNav.push(this.$store.state.mailbox[0]);
    this.index = 0;
    await this.changeBox();
    // this.selectFolder.push(this.selectNav[0].folders[0]);
    // Запускаем обновление писем каждые 10 секунд
    this.updateInterval = setInterval(() => {
      this.updateMails();
    }, 10000); // 10000 мс = 10 секунд
  },
  beforeUnmount() {
    // Очищаем интервал при уничтожении компонента
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
    }
  },
};
</script>
<style>
.v-list-item__prepend > .v-badge ~ .v-list-item__spacer,
.v-list-item__prepend > .v-icon ~ .v-list-item__spacer,
.v-list-item__prepend > .v-tooltip ~ .v-list-item__spacer {
  width: 12px;
}
</style>
